import { Button } from "@mui/material";
import { NavLink, useLocation } from "react-router-dom";
import ThanksImg from "../../assets/img/ad/deliva_blue_logo.svg";

export default function Thanks () {
    const location = useLocation();
    const name = location.state?.name?.trim() || '';

    return (
      <div className="container">
      <div className="thanks-container">
        <div className="thanks">

            <div className="thanks-img">
                <img src={ThanksImg} alt="thanks"/>
            </div>

            <div className="thanks-text">
                <h1>Thanks{name ? ` ${name}` : ''}</h1>
                <h3>One of our agents will be contacting you soon <br /> to create your coupon.</h3>
            </div>

            <div className="blue-btn button">
              <NavLink to="/">
                <Button>HOME</Button>
              </NavLink>
            </div>
        </div>
        <div className="logo-home"></div>
      </div>
      </div>
    )
  }
 